import { render } from "./TrendElement.vue?vue&type=template&id=4419c932"
import script from "./TrendElement.vue?vue&type=script&lang=js"
export * from "./TrendElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__